import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./page/Home";
import NotFound from "./page/NotFound";
// import Contact from "./page/Contact";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
//import CopyRight from "./layout/CopyRight";
import Newsletter from "./component/Newsletter";
// import CourtBookingSystem from "./page/CourtBookingSystem";
// import ClubPadel from "./page/Clubs/ClubPadel";
// import VamosPadelClub from "./page/Clubs/VamosPadelClub";
// import PadelFactory from "./page/Clubs/PadelFactory";
// import PadelEdge from "./page/Clubs/PadelEdge";
// import PadelPro from "./page/Clubs/PadelPro";
// import Arena360 from "./page/Clubs/Arena360";
// import PadelStar from "./page/Clubs/PadelStar";
// import ChampionsClub from "./page/Clubs/ChampionsClub";
import Check from "./page/Check";
// import  FAQ from "./page/FAQS";
// import TermsAndConditions from "./page/TermsandConditions";
// import PrivacyPolicy from "./page/PrivacyPolicy";
// import Availability from "./page/Availability";
// import Blog1 from "./page/essential-tennis-techniques-for-beginners";
// import Blog2 from "./page/AdvancedDoublesTactics";
// import Blog3 from "./page/FitnessTipsForSports";

const App = () => (
  <>
    <Header />
    <div className="page_wrapper">
      <Routes>
        {/* <Route path="/home" element={<Home />} /> */}
        {/* <Route path="/contact-us" element={<Contact />} /> */}
        {/* <Route path="/court-booking-system" element={<CourtBookingSystem />} /> */}
        {/* <Route path="/court-availability/club-padel" element={<ClubPadel />} /> */}
        {/* <Route
          path="/court-availability/padel-factory"
          element={<PadelFactory />}
        />
        <Route path="/court-availability/padel-edge" element={<PadelEdge />} />
        <Route path="/court-availability/padel-pro" element={<PadelPro />} />
        <Route path="/court-availability/arena-360" element={<Arena360 />} />
        <Route path="/court-availability/padel-star" element={<PadelStar />} />
        <Route
          path="/court-availability/champions-club"
          element={<ChampionsClub />}
        />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms-and-condition" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/essential-tennis-technique" element={<Blog1 />} />
        <Route path="/advanced-double-tactics" element={<Blog2 />} />
        <Route path="/fitness-tips-for-sports" element={<Blog3 />} />

        <Route path="/availability" element={<Availability />} */}

        {/* <Route
          path="/court-availability/vamos-padel-club"
          element={<VamosPadelClub />}
        /> */}
        <Route path="/" element={<Check />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
    <Newsletter />
    <Footer />
    {/* <CopyRight /> */}
  </>
);

export default App;
